import {
  bookingActionTypes,
  BookingReducerState,
} from '../Pages/Booking/client-state/reducers/bookingReducer';
import { customerReducerActionTypes, CustomerReducerState } from './customer-reducer';
import { errorReducerActionTypes } from './error-reducer';
import { vouchersReducerActionTypes, VouchersReducerState } from './vouchers-reducer';

export enum loadingReducerActionTypes {
  BOOKING = 'LOADING_BOOKING',
  CUSTOMER = 'LOADING_CUSTOMER',
  VOUCHERS = 'LOADING_VOUCHERS',
}

interface LoadingBookingAction {
  type: loadingReducerActionTypes.BOOKING;
  payload: boolean;
}

interface LoadingCustomerAction {
  type: loadingReducerActionTypes.CUSTOMER;
  payload: boolean;
}

interface LoadingVouchersAction {
  type: loadingReducerActionTypes.VOUCHERS;
  payload: boolean;
}

interface ErrorBookingCreateAction {
  type: errorReducerActionTypes.BOOKING_CREATE;
  payload: boolean;
}

interface BookingUpdateAction {
  type: bookingActionTypes.UPDATE_BOOKING;
  payload: Partial<BookingReducerState>;
}

interface CustomerUpdateAction {
  type: customerReducerActionTypes.UPDATE_CUSTOMER;
  payload: CustomerReducerState['customer'];
}

interface ErrorVoucherAction {
  type: errorReducerActionTypes.VOUCHER;
  payload: string;
}

interface VouchersUpdateAction {
  type: vouchersReducerActionTypes.UPDATE_VOUCHERS;
  payload: VouchersReducerState;
}

export type LoadingReducerAction =
  | LoadingBookingAction
  | LoadingCustomerAction
  | LoadingVouchersAction
  | ErrorBookingCreateAction
  | BookingUpdateAction
  | CustomerUpdateAction
  | ErrorVoucherAction
  | VouchersUpdateAction;

export interface LoadingReducerState {
  booking: boolean;
  customer: boolean;
  voucher: boolean;
}

export const loadingReducerInitialState: LoadingReducerState = {
  booking: false,
  customer: false,
  voucher: false,
};

const loadingReducer = (
  state: LoadingReducerState,
  action: LoadingReducerAction
): LoadingReducerState => {
  switch (action.type) {
    /**
     * Booking loading states
     */
    case loadingReducerActionTypes.BOOKING: {
      return {
        ...state,
        booking: action.payload,
      };
    }
    case errorReducerActionTypes.BOOKING_CREATE:
    case bookingActionTypes.UPDATE_BOOKING: {
      return {
        ...state,
        booking: false,
      };
    }

    /**
     * Customer loading states
     */
    case loadingReducerActionTypes.CUSTOMER: {
      return {
        ...state,
        customer: action.payload,
      };
    }
    case customerReducerActionTypes.UPDATE_CUSTOMER: {
      return {
        ...state,
        customer: false,
      };
    }

    /**
     * Voucher loading states
     */
    case loadingReducerActionTypes.VOUCHERS: {
      return {
        ...state,
        voucher: action.payload,
      };
    }
    case errorReducerActionTypes.VOUCHER:
    case vouchersReducerActionTypes.UPDATE_VOUCHERS: {
      return {
        ...state,
        voucher: false,
      };
    }

    default:
      return state;
  }
};

export default loadingReducer;
